import { gql } from '@apollo/client';

const DELETE_CURRICULA_MUTATION = gql`
    mutation deleteCurriculum( $curriculumID: UUID! ) {
        result: deleteCurriculum( curriculumID: $curriculumID ) {
            affectedRows
        }
    }
`;

export default DELETE_CURRICULA_MUTATION;
